
import { ChangeDetectorRef, Component, DestroyRef, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { CountDownTimerComponent } from '../../count-down-timer/count-down-timer.component';
import { UpgradeAvailabilityDTO } from '../../../model/upgradeAvailabilityDTO';
import { UiNewOfferNavBarComponent, UiNewOfferTab } from '../ui-new-offer-nav-bar/ui-new-offer-nav-bar.component';
import { LxResponsiveClassDirective } from '../../../directives/lx-responsive-class.directive';
import { AttentionFlashService, AttentionFlashTab } from '../../../_services/attention-flash.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ResponsiveMode } from '@app/enum/responsiveModes';
import { Subscription } from 'rxjs';
import { UiNewShoppingCartComponent } from '../ui-new-shopping-cart/ui-new-shopping-cart.component';
import { OfferCategoryService } from '../../../_services/offer-category.service';

export type UiNewViewMode = 'tiles' | 'list';
export const UI_NEW_VIEW_MODE_STORAGE_KEY = 'uiNewViewMode';

@Component({
  selector: 'ui-new-tabs-bar',
  standalone: true,
  imports: [
    UiNewOfferNavBarComponent,
    CountDownTimerComponent,
    UiNewShoppingCartComponent,
    LxResponsiveClassDirective
],
  templateUrl: './ui-new-tabs-bar.component.html',
  styleUrl: './ui-new-tabs-bar.component.scss',
})
export class UiNewTabsBarComponent implements OnInit{
  private readonly attentionFlash = inject(AttentionFlashService);
  private readonly offerCategoryService = inject(OfferCategoryService);
  private readonly destroyRef = inject(DestroyRef);

  @Input() upgradeAvailability: UpgradeAvailabilityDTO | null = null;
  @Input() selectedTab: UiNewOfferTab = 'ROOM';
  @Input() endDate: Date = new Date();
  @Input() viewMode: UiNewViewMode = 'tiles';
  @Input() showCart = true;
  @Input() offerCount: number | null = null;

  flashTimerRow = false;

  @Output() selectedTabChange = new EventEmitter<UiNewOfferTab>();
  @Output() viewModeChange = new EventEmitter<UiNewViewMode>();
  @Output() filterToggle = new EventEmitter<void>();

  viewResponsiveMode: ResponsiveMode | UiNewViewMode = ResponsiveMode.horizontal;
  responsiveMode = ResponsiveMode;

  private breakpointSubscription?: Subscription;

  constructor(private responsive: BreakpointObserver,
              private cdr: ChangeDetectorRef
  ) {
    const sub = this.attentionFlash.flash$.subscribe(evt => {
      if (evt.target.kind !== 'timer-row') return;
      this.flashTimerRow = evt.active;
    });

    this.destroyRef.onDestroy(() => sub.unsubscribe());
  }

  ngOnInit(): void {
    this.breakpointSubscription = this.responsive.observe([Breakpoints.HandsetPortrait])
      .subscribe(result => {
        this.viewResponsiveMode = result.matches ? ResponsiveMode.vertical : ResponsiveMode.horizontal;
        this.cdr.detectChanges();
      });

  }

  runAttentionSequence(): void {
    // Keep ordering consistent with the demo: room → eci → lco → addon → timer
    const visibleTabs: AttentionFlashTab[] = this.offerCategoryService.getVisibleTabsForAttention(
      this.upgradeAvailability,
    );

    this.attentionFlash.restartSequenceFromNavBar(visibleTabs);
  }

  setViewMode(mode: UiNewViewMode) {
    try {
      localStorage.setItem(UI_NEW_VIEW_MODE_STORAGE_KEY, mode);
    } catch {
      // ignore (some environments block storage writes)
    }

    this.viewModeChange.emit(mode);
  }
}
